import { useEffect, useState } from "react"
import { Link, useLoaderData, useLocation, useNavigate, useOutletContext } from "react-router-dom"

import axios from "axios"
import { useAuth } from "contexts/auth-context"
import { useLayoutEffect } from "react"
import Form from "./form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import { useAuditLogContext } from "contexts/audit-log-context"
import moment from "moment"
import { max } from "lodash"

export default function Edit() {
    const { user } = useAuth()
    const { cache } = useSWRConfig()

    const { queueAuditLog } = useAuditLogContext()

    const { setTransition } = usePage()

    const { setTitle } = useOutletContext()

    const loaderData = useLoaderData()

    const location = useLocation()
    const navigate = useNavigate()

    const [prevRouteState, setPrevRouteState] = useState({})

    const [errors, setErrors] = useState({})

    useLayoutEffect(() => {
        const getPrevRouteState = async () => {
            setPrevRouteState({
                back: location.state?.back,
                from: location.state?.from,
                transition: location.state?.transition
            })
        }

        setTransition(location.state?.transition)
        setTitle(`Edit ${loaderData?.name}`)

        getPrevRouteState()
    }, [])

    const handleSubmit = (data) => {
        nProgress.start()

        toast.loading("Loading", {
            id: "submit"
        })

        const url = `${process.env.REACT_APP_INVENTORY_API_URL}/discount/${data?.id}`
        const oldData = {
            name: loaderData.name,
            max_sales_item_count: loaderData.max_sales_item_count === null || loaderData.max_sales_item_count === 0 ? 0 : loaderData.max_sales_item_count,
            sales_item_count: loaderData.sales_item_count,
            starting_item_number: loaderData.starting_item_number,
            amount: Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(loaderData.amount),
            percentage: loaderData.percentage,
            multiply: loaderData.multiply ? 1 : 0,
            updated_by: loaderData.updated_by,

            dependency: loaderData.dependencies,
            giveaway: loaderData.giveaways
        }
        const auditLogPayload = {
            name: data.name,
            max_sales_item_count: data.max_sales_item_count === "" || data.max_sales_item_count === 0 ? 0 : data.max_sales_item_count,
            sales_item_count: data.sales_item_count,
            starting_item_number: data.starting_item_number,
            amount: Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(data.amount),
            percentage: data.percentage,
            multiply: data.multiply ? 1 : 0,
            updated_by: user?.name,

            dependency: data.dependency,
            giveaway: data.giveaway
        }
        const formPayload = {
            name: data.name,
            sales_item_count: data.sales_item_count,
            max_sales_item_count: data.max_sales_item_count === "" || data.max_sales_item_count === 0 ? 0 : data.max_sales_item_count,
            starting_item_number: data.starting_item_number,
            amount: data.amount,
            percentage: data.percentage,
            multiply: data.multiply ? 1 : 0,
            updated_by: user?.name,

            dependency: data.dependency,
            giveaway: data.giveaway
        }

        axios.patch(url, formPayload).then((response) => {
            // Queue audit log
            queueAuditLog(url, response.config.method.toUpperCase(), "Edit Discount Data", user?.name, { old: oldData, new: auditLogPayload }, null, moment().format('YYYY-MM-DD HH:mm:ss'), response.status)

            // Clear SWR cache
            cache.clear()

            // Navigate page
            navigate({ pathname: '/discount' })

            // Show toast message
            toast.success(response.data.message, {
                id: "submit"
            })
        }).catch((error) => {
            // Assign validation message
            if (error.response.status === 422) {
                setErrors(error.response.data.errors)
            }

            // Show toast message
            toast.error(error.response.data.message, {
                ariaProps: {
                    superscript: error.response.status
                },
                id: "submit"
            })
        })
    }

    return (
        <Form data={loaderData} errors={errors} onSubmit={handleSubmit} />
    )
}